var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","fill":"none"}},[_c('path',{staticClass:"icon-color--lighten5",class:{
      'icon-color--highlight-success': _vm.successVersion,
      'icon-color--lighten4': _vm.disabled
    },attrs:{"d":"M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{class:{
      'icon-color--highlight-success': _vm.successVersion,
      'icon-color--lighten4': _vm.disabled
    },attrs:{"d":"M7.75 12L10.58 14.83L16.25 9.17001","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }